export default __webpack_public_path__ + "static/media/marc14.bb616ef3.jpg";